import type { ReactNode } from 'react'

import { useUnsubscribePresubscriberMutation } from '@/src/features/settings/services/useUnsubscribePresubscriberMutation'
import { useToast } from '@/src/general/components/ToastContext'
import { useSearchParamsAction } from '@/src/general/hooks/useSearchParamsAction'
import { useTranslate } from '@/src/lang/useTranslate'

export const CommunitySearchParamsActions = ({ searchParams }: TSearchParamsParam): ReactNode => {
  const { mutateAsync } = useUnsubscribePresubscriberMutation()
  const { addToast } = useToast()
  const { t } = useTranslate()

  useSearchParamsAction({
    searchParams,
    action: ({ email }) => {
      if (typeof email !== 'string') return
      mutateAsync(email)
        .then(() => {
          addToast({ colors: 'success', message: t('settings.unsubscribe-presubscriber.success') })
        })
        .catch((error) => {
          if (error?.status === 404) {
            addToast({ colors: 'success', message: t('settings.unsubscribe-presubscriber.success') })
          } else {
            addToast({ colors: 'danger', message: t('settings.unsubscribe-presubscriber.error') })
          }
        })
    },
    requestedQuery: { action: 'unsubscribe-presubscriber', email: (value) => !!String(value) },
  })

  useSearchParamsAction({
    searchParams,
    action: ({ message }) => {
      if (typeof message !== 'string') return
      addToast({ colors: 'danger', message })
    },
    requestedQuery: { action: 'message', message: (value) => !!value },
  })

  return null
}
